import { AxiosService } from './axiosService';

export class UtilityAccountService extends AxiosService {
    async getUtilityAccounts(sortState, page, pageSize, groupId) {
        try {
            const { data } = await this.axios.post('/utility', {
                SortBy: sortState[0].fieldName,
                OrderBy: sortState[0].dir,
                PageSize: pageSize,
                PageIndex: page,
                ...(groupId != null && { GroupId: groupId }),
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async createUtilityAccount(utilityAccount) {
        try {
            const { data } = await this.axios.post('/utility/create', utilityAccount);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteUtilityAccount(utilityAccountId) {
        console.log(utilityAccountId);
        try {
            const { data } = await this.axios.get(`/utility/delete?utilityAccountId=${utilityAccountId}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async updateUtilityAccount(utilityAccount) {
        try {
            const { data } = await this.axios.post('/utility/update', utilityAccount);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }



    async getUtilityAccountRates(utilityAccountId) {
        try {
            const { data } = await this.axios.post('/utilityrates/get', utilityAccountId);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async updateUtilityAccountRates(request) {
        try {
            const { data } = await this.axios.post('/utilityrates/update',request);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async createUtilityAccountRates(request) {
        try {
            const { data } = await this.axios.post('/utilityrates/create',request);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteUtilityAccountRates(UtilityAccountRateId) {
        try {
            console.log(UtilityAccountRateId);
            const { data } = await this.axios.post('/utilityrates/delete?utilityRateId='+UtilityAccountRateId);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const utilityAccountService = new UtilityAccountService();
